<template>
  <section id="hero" class="hero section dark-background">
    <div class="container">
      <div class="row gy-4">
        <div class="col-lg-4 order-lg-last hero-img" data-aos="zoom-out">
          <!-- <img src="../land/assets/img/marcheganhi.png" alt="Phone 1" class="phone-1" /> -->
          <img src="../land/assets/img/marche.png" alt="Phone 1" class="phone-1" />
          <!-- <img src="../land/assets/img/marche2.png" alt="Phone 2" class="phone-2" /> -->
          <!-- <img src="../land/assets/img/marcheganhi.png" alt="Phone 2" class="phone-2" /> -->
        </div>
        <div
          class="col-lg-8 d-flex flex-column justify-content-center align-items text-center text-md-start"
          data-aos="fade-up"
        >
          <h2>Nos marchés modernes sont désormais à votre service.</h2>
          <p> Obtenez en toute transparence la place qu'il vous faut dans nos marchés.</p>
          <div class="d-flex mt-4 justify-content-center justify-content-md-start" >
            <router-link  class="download-btn lien" to="/e-processus">
              <i class="bi bi-credit-card"></i>
              <span>Procéder au paiement</span>
            </router-link>
            <!--<router-link to="/" class="download-btn lien">
              <i class="bi bi-newspaper"></i> 
              <span>Actualités</span>
            </router-link>-->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  name: "SectionOne",
  components: {},
  setup() {
    
  return {};
},
});
</script>
<style scoped>
.lien {
  text-decoration: none;
}
h1, h2, h3, h4, h5, h6 {
    color: #fff;
}
</style>